import type { AppointmentTimeTagInput } from "../../../../../../../../../../../_shared/_logic/appointment-time-tags"
import type { ScheduleEventCommunicationPresentation } from "../../../../../../../../../../../api/kehrblatt/work-orders"
export {
  buildLetterOrderTag,
  type LetterOrderReference,
} from "../../../../../../../../../_shared/_logic/letter-order-tag"

export type LetterAppointment = AppointmentTimeTagInput & {
  schedule_event_id: string
  status?: string | null
  employee_name?: string | null
  appointment_contact_name?: string | null
}
export type LetterAppointmentContext = {
  appointment?: LetterAppointment | null
  communication_presentation?: ScheduleEventCommunicationPresentation | null
}
export const parseLetterAppointmentContext = (
  source: Record<string, unknown>,
): LetterAppointmentContext => {
  const appointment = source.appointment
  const communication = source.communication_presentation

  if (
    appointment != null &&
    (typeof appointment !== "object" ||
      typeof (appointment as LetterAppointment).schedule_event_id !== "string")
  ) {
    throw new Error("Ungültige Termindaten des Briefs.")
  }

  if (
    communication != null &&
    (typeof communication !== "object" ||
      typeof (communication as ScheduleEventCommunicationPresentation).state !== "string")
  ) {
    throw new Error("Ungültiger Ankündigungsstatus des Briefs.")
  }

  if (
    appointment &&
    communication &&
    (appointment as LetterAppointment).schedule_event_id !==
      (communication as ScheduleEventCommunicationPresentation).schedule_event_id
  ) {
    throw new Error("Der Ankündigungsstatus gehört zu einem anderen Termin.")
  }

  return {
    appointment: appointment as LetterAppointment | null,
    communication_presentation: communication as ScheduleEventCommunicationPresentation | null,
  }
}
